// extracted by mini-css-extract-plugin
export default {"primary":"textarea_primary__mpHFZ","textarea":"textarea_textarea__jgBoI","disabled":"textarea_disabled__8O2VK","isLoading":"textarea_isLoading__Z0NTY"};